export const environment = {
  production: false,
  GATEWAY_URL: 'https://gca.traces.com.co/api/v1/dev',
  WEBSOCKET_URL: 'wss://gca.traces.com.co/api/v1/dev/updates',
  ACTIVE_DEVICES: true,
  GOOGLE_MAPS_API_KEY: 'AIzaSyB3dtM0sta3lg4NFArfNZWxTqBtnhNjXao',
  TIME_OUT_DIALOG: 2000,
  MAP_INFO_HEATMAP: false,
  APP_CONFIG: true,
  SHOW_SIDEBAR_ROAD_MANAGEMENT: true,
  SHOW_ISSUE_REPORT_BUTTON: false,
  INITIAL_COORDINATES: {
    latitude: 4.60971,
    longitude: -74.08175
  },
  DIGITIZATION_MAX_TIME_ALLOWED: 40,
  DIGITIZATION_AUTOSYNC_TIME: 10600,
  DIGITIZATION_FORM_AUTOSAVE_DELAY: 2000,
  MULTI_DIGIT_INPUT_TIME: 300
};
